import { v4 as uuid } from 'uuid';

export type ExampleInspection = {
  id: string;
  taskId: string;
  description: string;
  inspectionDate: string;
  typeName: string;
  siteName: string;
  turbineName: string;
  assetType: string;
  asset: string;
  vendor: string;
};
export const EXAMPLE_INSPECTIONS: ExampleInspection[] = [
  {
    id: uuid(),
    taskId: uuid(),
    description: 'Inspection 1 description',
    inspectionDate: '2025-05-21',
    typeName: 'Blade External Other',
    siteName: 'Site A',
    turbineName: 'WTG 0',
    assetType: '',
    asset: '',
    vendor: 'SkySpecs',
  },
  {
    id: uuid(),
    taskId: uuid(),
    description: 'Inspection 2 description',
    inspectionDate: '2025-06-15',
    typeName: 'Blade External Other',
    siteName: 'Site B',
    turbineName: 'WTG 1',
    assetType: '',
    asset: '',
    vendor: 'Third Party A',
  },
];

export type ExampleImageDetails = {
  id: string;
  taskId: string;
  path: string;
  imageUrl: string;
  blade: string;
  bladeSide: string;
  radialDistance: number | '';
  height: number | '';
  direction: string;
};
export const EXAMPLE_IMAGE_DETAILS: ExampleImageDetails[] = [
  {
    id: uuid(),
    taskId: uuid(),
    path: 'path/to/image1',
    imageUrl: 'https://example.com/image1',
    blade: 'A',
    bladeSide: 'suction_side',
    radialDistance: 8.3,
    height: '',
    direction: '',
  },
  {
    id: uuid(),
    taskId: uuid(),
    path: 'path/to/image2',
    imageUrl: 'https://example.com/image2',
    blade: 'A',
    bladeSide: 'suction_side',
    radialDistance: 10.2,
    height: '',
    direction: '',
  },
];
